module.exports = __webpack_public_path__ + "static/media/IMG_0554.007d2a0e.jpg";